<template>
  <div class="content-image">
      <img :src="imgSrc" ref="imgContainer" />
  </div>
</template>


<script>
import GphApiClient from 'giphy-js-sdk-core';

const giffyClient = GphApiClient('0iN99ST5SvmZThQRu94KxSf39xSoUKyD');

export default {
  props: ['imgSrc'],
  name: 'ContentImage',
  mounted() {
    this.$emit('imageInit');
  },
};
</script>

<style lang="scss" scoped>
.content-image {
  display: flex;
  justify-content: flex-end;
  

  img {
    height: 150px;
    margin: 1em 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ContentImage.vue